import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useImperativeHandle, useRef } from "react";
import { stringToParsedTokenArray } from "@poscon/shared-types/eram";
import { useRootSelector } from "../stateSelectors.js";
import { EramPrompt } from "./EramPrompt.js";
import { eramFontDimensionMap, eramFontNameMap, getBitmapTextStyles } from "../../eramFont.js";
import { colorNameMap } from "../../colorNameMap.js";
import { sectorIdSelector } from "../slices/connectionSlice.js";
import { MenuElement } from "./MenuElement.js";
import { baseEramHubConnection } from "../../eramHubConnectionFactory";
import { useCenterCursor } from "../hooks/useCenterCursor";
const fontFamily = eramFontNameMap[2];
const { width: fontWidth, height: fontHeight } = eramFontDimensionMap[fontFamily];
const defaultTint = colorNameMap.lightGrey;
const receivingTint = colorNameMap.cyan;
const initiatingTint = colorNameMap.yellow;
export const PoMenu = ({ sectorTrack, fp, closeMenu, dispatchCommand, ref, ...promptProps }) => {
    const localRef = useRef(null);
    useCenterCursor(localRef);
    const sectorId = useRootSelector(sectorIdSelector);
    useEffect(() => {
        if (sectorTrack.pointouts.length === 0) {
            closeMenu();
        }
    }, [closeMenu, sectorTrack.pointouts.length]);
    let x = fontWidth + 8;
    const width = Math.max(fontWidth * 10, sectorTrack.pointouts.reduce((acc, po) => acc + fontWidth * ((po.from === sectorId ? po.toShort : po.fromShort) ?? "UNK").length + 8, fontWidth + 8)) + 8;
    const tint = sectorTrack.pointouts.some((po) => po.from === sectorId && !po.acknowledged)
        ? initiatingTint
        : sectorTrack.pointouts.some((po) => po.to === sectorId && !po.acknowledged)
            ? receivingTint
            : defaultTint;
    const unackPointoutsExist = sectorTrack.pointouts.some((po) => !po.acknowledged);
    useImperativeHandle(ref, () => {
        return localRef.current;
    }, []);
    return (_jsx(EramPrompt, { ref: localRef, title: fp.callsign, width: width, height: fontHeight + 7, closeMenu: closeMenu, showX: true, ...promptProps, children: _jsxs("container", { x: 4, y: 3, children: [_jsx("bitmapText", { x: 2, y: 2, text: unackPointoutsExist ? "P" : "A", style: { ...getBitmapTextStyles(fontFamily), fill: tint } }), sectorTrack.pointouts.length > 0 &&
                    sectorTrack.pointouts.map((po) => {
                        const text = (po.from === sectorId ? po.toShort : po.fromShort) ?? "UNK";
                        const _x = x;
                        x += fontWidth * text.length + 8;
                        const tint = po.acknowledged
                            ? defaultTint
                            : po.from === sectorId
                                ? initiatingTint
                                : receivingTint;
                        return (_jsx(MenuElement, { x: _x, text: text, tint: tint, borderColor: tint, fillColor: 0, onmousedown: () => {
                                if (po.acknowledged) {
                                    baseEramHubConnection.emit("removePointout", sectorTrack.trackId, po.from, po.to);
                                }
                                else if (po.to === sectorId) {
                                    dispatchCommand(stringToParsedTokenArray(`QP A ${po.fromShort} ${fp.cid ?? fp.callsign}`));
                                }
                            } }, po.from === sectorId ? po.to : po.from));
                    })] }) }));
};
//# sourceMappingURL=PoMenu.js.map